import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Slide {
  image: string;
  kicker: string;
  title: string;
  desc: string;
  to: string;
}

const slides: Slide[] = [
  {
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20standing%20in%20a%20misty%20green%20valley%20at%20dawn%2C%20artistic%20soft%20lighting%2C%20muted%20warm%20and%20sage%20tones%2C%20editorial%20film%20photography%2C%20high%20detail&width=1920&height=1080&seq=hero-01&orientation=landscape",
    kicker: "最新电影",
    title: "《风之谷》",
    desc: "濑户环奈主演年度奇幻新作，关于自然与重生的温柔寓言，先导预告已公开。",
    to: "/works/fengzhigu",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20night%20shot%20of%20a%20young%20Japanese%20woman%20in%20an%20elegant%20dress%20on%20a%20glamorous%20city%20street%2C%20warm%20golden%20lighting%2C%20rich%20tones%2C%20editorial%20film%20photography%2C%20high%20detail&width=1920&height=1080&seq=hero-02&orientation=landscape",
    kicker: "热播剧集",
    title: "《银座之夜》",
    desc: "以银座为舞台的话题群像剧，看濑户环奈如何演绎聪慧果断的年轻老板娘。",
    to: "/works/yinzuo-zhiye",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20film%20festival%20red%20carpet%20with%20warm%20event%20lighting%20and%20blurred%20photographers%2C%20elegant%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1920&height=1080&seq=hero-03&orientation=landscape",
    kicker: "最新动态",
    title: "东京国际电影节红毯",
    desc: "濑户环奈一袭优雅礼服亮相红毯，为新片《海边的信》站台，造型获评最佳着装。",
    to: "/news/tokyo-film-festival",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [paused]);

  const go = (next: number) => setIndex((next + slides.length) % slides.length);

  return (
    <section
      className="relative w-full h-[460px] md:h-[600px] overflow-hidden"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-label="焦点推荐"
    >
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 焦点图`}
            title={`${slide.title} - 濑户环奈资讯`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/40 to-foreground-950/20"></div>
        </div>
      ))}

      <div className="relative z-10 h-full w-full flex items-end">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-8 pb-14 md:pb-20">
          <div key={index} className="animate-fade-up max-w-2xl">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 mb-4">
              {slides[index].kicker}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
              {slides[index].title}
            </h2>
            <p className="text-sm md:text-base text-background-100/90 mb-6 leading-relaxed max-w-xl">
              {slides[index].desc}
            </p>
            <Link
              to={slides[index].to}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看详情
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={() => go(index - 1)}
        aria-label="上一张"
        className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-background-50/25 text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer backdrop-blur"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        onClick={() => go(index + 1)}
        aria-label="下一张"
        className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-background-50/25 text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer backdrop-blur"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-6 right-4 md:right-8 z-20 flex items-center gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => go(i)}
            aria-label={`切换到第 ${i + 1} 张`}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? "w-8 bg-primary-400" : "w-3 bg-background-50/60 hover:bg-background-50"
            }`}
          />
        ))}
      </div>
    </section>
  );
}